import { ProjectDatesSchema } from "../../models/project/ProjectDatesSchema";

/** Minimal schema property describing an editable date field. */
const DATE_PROPERTY = { type: "string", format: "date" };
/** Minimal schema property describing an editable number field. */
const NUMBER_PROPERTY = { type: "number" };

/**
 * Fallback date schema used when a project has no standard-specific schema
 * (`standardSpecificSchemaUuid` is null, so no dateSchema loads and `dateSchema` stays undefined).
 *
 * It contains only the core dates that were always editable before dates became schema-driven — each
 * phase's start/end, the ongoing-monitoring overall start/end, and the project duration — so those
 * controls never disappear for schema-less projects. Schema-defined optional fields (registration
 * date, certification date, monitoring frequency, …) intentionally stay absent until a real schema
 * provides them.
 *
 * A real schema always carries start/end for every phase, so `dateSchema ?? FALLBACK` is enough — no
 * merge is required.
 */
export const FALLBACK_PROJECT_DATES_SCHEMA: ProjectDatesSchema = {
  feasibility: {
    properties: {
      start: DATE_PROPERTY,
      end: DATE_PROPERTY,
    },
  },
  design: {
    properties: {
      start: DATE_PROPERTY,
      end: DATE_PROPERTY,
    },
  },
  implementation: {
    properties: {
      start: DATE_PROPERTY,
      end: DATE_PROPERTY,
    },
  },
  duration: {
    properties: {
      duration: NUMBER_PROPERTY,
    },
  },
  ongoingMonitoring: {
    properties: {
      cycles: [],
      overallEnd: DATE_PROPERTY,
      overallStart: DATE_PROPERTY,
    },
  },
};
